class FeaturedArticles extends HTMLElement {
  constructor() {
    super();
    this.createSlider();
  }

  createSlider() {
    let drag = false;
    const slider = new KeenSlider(".featured-articles-slider", {
      dragChecked() {
        drag = true;
      },
      dragEnded() {
        setTimeout(() => (drag = false), 0);
      },
      created() {
        document.querySelector('.featured-articles-slider').addEventListener("click", (e) => {
          if (drag) {
            e.stopPropagation();
            e.preventDefault();
          }
        })
      },
      breakpoints: {
        '(max-width: 449px)': {
          slides: {
            perView: 1.3,
            spacing: 16
          }
        },
        '(min-width: 450px)': {
          slides: {
            perView: 1.5,
            spacing: 24
          }
        },
        '(min-width: 750px)': {
          slides: {
            perView: 2.5,
            spacing: 24
          }
        },
        '(min-width: 1200px)': {
          disabled: true,
        },
      },
    });
  }
}

customElements.define('featured-articles', FeaturedArticles);